<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Site Incidents"
              icon="fas fa-list"
              buttonLabel="REPORT INCIDENT"
              buttonIcon="fas fa-plus"
              (buttonClick)="reportIncidentModal()">
          </card-section-header>
            <div class="row">
              <div class="col-md-10">
                <div class="filter-flex-row">
                  <div>
                    <label>Status</label>
                    <p-dropdown class="form-control squareDropdown" [(ngModel)]="selectedStatusFilter" [options]="statusFilter" optionLabel="label" (onChange)="onFilterChanged($event)"></p-dropdown>
                  </div>
                  <div>
                    <label>From Date</label>
                    <p-calendar class="form-control squareDropdown" [(ngModel)]="fromDateFilter" (ngModelChange)="onFilterChanged($event)" dateFormat="dd/mm/yy" [yearNavigator]="true" [yearRange]="datepickerYearRange" [monthNavigator]="true"></p-calendar>
                  </div>
                  <div>
                    <label>To Date</label>
                    <p-calendar class="form-control squareDropdown" [(ngModel)]="toDateFilter" (ngModelChange)="onFilterChanged($event)" dateFormat="dd/mm/yy" [yearNavigator]="true" [yearRange]="datepickerYearRange" [monthNavigator]="true"></p-calendar>
                  </div>
                  <div *ngIf="isFilterLoading" class="small-spinner">
                    <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                  </div>
                </div>
                <br>
              </div>
            </div>
            <div class="mb-2 animated fadeIn">
              <!-- Table of results -->
              <div class="row">
                <div class="col-md-12" *ngIf="selectedSite">
                  <p-table [value]="incidents" [autoLayout]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th style="width:25%">Incident Description</th>
                        <th style="width:20%">Resolution</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Severity</th>
                        <th>Reported By</th>
                        <th>Reported Date</th>
                        <th>Last Modified By</th>
                        <th></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-incident>
                      <tr>
                        <td><p class="asset-restriction"><i *ngIf="incident.isReportedEmergency" class="fas fa-exclamation-triangle flashing"></i>&nbsp;{{ incident.description }}</p></td>
                        <td><p>{{ incident.resolution }}</p></td>
                        <td>{{ incident.typeLiteral }}</td>
                        <td>{{ incident.statusLiteral }}</td>
                        <td>{{ incident.severityLiteral }}</td>
                        <td><a href="javascript:void(0)" (click)="viewUser(incident)">{{ incident.reportedByName }}</a></td>
                        <td><date-friendly [value]="incident.createdDate"></date-friendly></td>
                        <td>{{ incident.lastModifiedBy }}</td>
                        <td><button type="button" class="btn btn-danger btn-link" (click)="updateIncident(incident)">edit</button></td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                      <tr>
                        <td [attr.colspan]="9">No incidents found</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <p-paginator #paginator [rows]="pagination.size" [totalRecords]="pagination.totalRecords" [rowsPerPageOptions]="pageSizes" (onPageChange)="paginate($event)"></p-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Report an incident -->
<p-dialog header="Report An Incident" [(visible)]="showReportIncidentModal" modal="true"  [style]="{'min-width': '600px'}" [dismissableMask]="true" [baseZIndex]="1000000">
  <form [formGroup]="reportIncidentForm" (ngSubmit)="onReportIncidentFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Incident Description <span class="required-star">*</span></label>
          <textarea type="text" class="form-control" formControlName="description"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Resolution</label>
          <textarea type="text" class="form-control" formControlName="resolution"></textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Type<span class="required-star"> *</span></label>
          <p-dropdown class="form-control"
            formControlName="type"
            [options]="incidentType"
            optionLabel="label"
            placeholder="Select Incident Type...">
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Type<span class="required-star"> *</span></label>
          <p-dropdown class="form-control"
            formControlName="severity"
            [options]="severity"
            optionLabel="label"
            placeholder="Select Incident Severity...">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="showReportIncidentModal = false" class="my-2 btn btn-round btn-sm btn-default">Cancel</button>
    <button type="button" (click)="onReportIncidentFormSubmit()" [disabled]="!reportIncidentForm.valid || isSaving" class="my-2 btn btn-round btn-sm btn-success">Report Incident</button>
  </p-footer>
</p-dialog>


<!-- Update an incident -->
<p-dialog header="Update An Incident" [(visible)]="showUpdateIncidentModal" modal="true"  [style]="{'min-width': '600px'}" [dismissableMask]="true" [baseZIndex]="1000000">
  <form [formGroup]="updateIncidentForm" (ngSubmit)="onUpdateIncidentFormSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Incident Description <span class="required-star">*</span></label>
          <textarea type="text" class="form-control" formControlName="description"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Resolution</label>
          <textarea type="text" class="form-control" formControlName="resolution"></textarea>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Type<span class="required-star"> *</span></label>
          <p-dropdown class="form-control"
            formControlName="type"
            [options]="incidentType"
            optionLabel="label"
            placeholder="Select Incident Type...">
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Severity<span class="required-star"> *</span></label>
          <p-dropdown class="form-control"
            formControlName="severity"
            [options]="severity"
            optionLabel="label"
            placeholder="Select Incident Severity...">
          </p-dropdown>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Status<span class="required-star"> *</span></label>
          <p-dropdown class="form-control"
            formControlName="status"
            [options]="status"
            optionLabel="label"
            placeholder="Select Incident Severity...">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="showUpdateIncidentModal = false" class="my-2 btn btn-round btn-sm btn-default">Cancel</button>
    <button type="button" (click)="onUpdateIncidentFormSubmit()" [disabled]="!updateIncidentForm.valid || isSaving" class="my-2 btn btn-round btn-sm btn-success">Update Incident</button>
  </p-footer>
</p-dialog>

<p-dialog *ngIf="selectedIncident" header="User {{ selectedIncident.reportedByName }}" [(visible)]="showUserModal" [dismissableMask]="true" modal="true">
  <div class="row">
    <div class="col-md-6">
      <ul class="list-group list-group-flush">
        <li class="list-group-item"><strong>User:</strong> {{ selectedIncident.reportedByName }}</li>
        <li class="list-group-item"><strong>Email:</strong>&nbsp;<a href="mailTo:{{ selectedIncident.reportedByEmail }}">{{ selectedIncident.reportedByEmail }}</a></li>

      </ul>
    </div>
    <div class="col-md-6">
      <ul class="list-group list-group-flush">
        <li class="list-group-item"><strong>Phone:</strong> {{ selectedIncident.reportedByPhone }}</li>
        <li *ngIf="selectedIncident.reportedByContractor" class="list-group-item"><strong>Contractor:</strong> {{ selectedIncident.reportedByContractor }}</li>
      </ul>
    </div>
  </div>
</p-dialog>
